export default "__VITE_ASSET__DYCnoHBR__"